import React from 'react';
import { useParams } from 'react-router';

import { useCanReadProcessData } from '@/utils/usePermissions.util.ts';
import { ContactDetailsProcesses } from '@/views/contactsDetails/components/processes/ContactDetailsProcesses.comp.tsx';

export const ContactDetailsProcessesTab: React.FC = () => {
  const { contactId } = useParams();
  const canReadProcessData = useCanReadProcessData();

  if (!contactId || !canReadProcessData) {
    return null;
  }

  return <ContactDetailsProcesses contactId={Number.parseInt(contactId)} />;
};
